import { ValuationPreview } from '@/interfaces/valuation/ValuationRecord'
import client from '@/services/api/client'
import createMessage from '@/services/app/createMessage'
import { MessageType } from '@/interfaces/app/Message'

interface ValuationSearchState {
  previews: ValuationPreview[]
}

export default {
  namespaced: true,
  state: {
    previews: [],
  },
  mutations: {
    setPreviews(state: ValuationSearchState, data: ValuationPreview[]) {
      state.previews = data
    },
  },
  actions: {
    async fetchPreviews(
      {
        commit,
        dispatch,
      }: {
        [propName: string]: any
      },
      searchText: string
    ) {
      commit('app/setLoading', true, { root: true })
      return client({
        url: `/v1/valuation/search/${searchText}`,
        method: 'GET',
      })
        .then(previewsData => {
          const previews: ValuationPreview[] = []
          for (const preview of previewsData.data) {
            previews.push(new ValuationPreview(preview))
          }
          commit('setPreviews', previews)
        })
        .catch(err => {
          const message = createMessage(
            'Valuace se nepodařilo načíst. Zkuste to prosím později.',
            MessageType.Error
          )
          dispatch(
            'app/addTempMessage',
            { message, timeout: 3500 },
            { root: true }
          )
        })
        .finally(() => commit('app/setLoading', false, { root: true }))
    },
  },
  getters: {
    previews: (state: ValuationSearchState): ValuationPreview[] =>
      state.previews,
  },
}
